// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18FYT","toggle":"styles_toggle__1QR7W","preview":"styles_preview__2aOZY"};